<template>
  <div
    class="past-months-summary-widget-view"
    :style="style"
  >
    <div class="widget-wrapper">
      <div
        class="breakdown-table"
        :class="{ 'disabled': shouldShowEmptyState }"
        :style="breakdownTableStyle"
      >
        <div
          v-if="shouldShowEmptyState"
          class="connect-another-subtitle missing-data-subtitle"
        >
          Unlock your last 6 months' summary by <b @click="handleConnectAccountsClick">connecting your current account</b>
        </div>
        <div class="breakdown-content">
          <div class="breakdown-row">
            <div class="col source" :style="{ color: widget.textColor, fontSize: widget.fontSize + 'px' }">
              Average monthly <b>income</b>
            </div>
            <div class="col invest"
              :style="{ color: widget.textColor, fontSize: widget.fontSize + 'px' }">
              £{{ numberToHumanReadable(variableData.income) }}
            </div>
          </div>

          <div class="breakdown-row">
            <div class="col source" :style="{ color: widget.textColor, fontSize: widget.fontSize + 'px' }">
              Average monthly <b>spending</b>
            </div>
            <div class="col invest" :style="{ color: widget.textColor, fontSize: widget.fontSize + 'px' }">
              £{{ numberToHumanReadable(variableData.spending) }}
            </div>
          </div>

          <div class="breakdown-row breakdown-total-row">
            <div class="col source" :style="{ color: widget.textColor, fontSize: widget.fontSize + 'px' }">
              Your monthly <b>net balance</b>
            </div>
            <div
              class="col invest"
              :style="{
                color: widget.totalColor,
                fontSize: widget.fontSize + 'px'
              }"
            >
              £{{ numberToHumanReadable(variableData.total) }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'PastMonthsSummaryWidgetView',
  props: {
    widget: {
      type: Object,
    },
  },
  computed: {
    style() {
      return {
        top: `${this.widget.top}px`,
        zIndex: this.widget.zIndex,
        fontFamily: this.widget.fontFamily,
        width: `${this.widget.width}px`,
        marginTop: `${this.widget.marginTop}px`,
        marginBottom: `${this.widget.marginBottom}px`,
      };
    },
    breakdownTableStyle() {
      return {
        boxShadow: this.widget.boxShadow,
        borderRadius: `${this.widget.borderRadius}px`,
      };
    },
    hasRealData() {
      const data = this.widget.variableData;
      if (!data || !Array.isArray(data) || data.length === 0) {
        return false;
      }
      // Query results could be a list(array), number or a string
      // The component expects an object with income, spending and total
      // so we adapt to the first item in the array
      return _.every(Object.values(data[0]), value => value !== undefined);
    },
    variableData() {
      if (this.hasRealData) {
        // see comment above about the data structure of the query result
        const data = this.widget.variableData[0];
        // Ensure all required fields are present, set missing ones to 0
        return {
          income: data.income !== undefined ? data.income : 0,
          spending: data.spending !== undefined ? data.spending : 0,
          total: data.total !== undefined ? data.total : 0,
        };
      }

      return {
        income: 0,
        spending: 0,
        total: 0,
      };
    },
    shouldShowEmptyState() {
      const data = this.variableData;
      return !this.hasRealData || _.some(Object.values(data), value => value === 0);
    },
  },
  methods: {
    handleConnectAccountsClick() {
      this.$emit('userInteraction', {
        eventName: 'connectAccountsClicked',
      });
    },
    numberToHumanReadable(num) {
      if (typeof num !== 'number') {
        return num;
      }

      return num.toLocaleString('en-GB', {
        maximumFractionDigits: 0,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.past-months-summary-widget-view {
  position: absolute;
  display: flex;
  left: 0;

  .widget-wrapper {
    width: 100%;
    margin-right: 30px;
    margin-left: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}

.breakdown-table {
  width: 100%;
  background-color: white;
  padding: 25px;
  z-index: 2;
  margin: 0 auto;
  position: relative;
  padding-top: 30px;

  &.disabled {
    background-color: #F1F5FA !important;
    box-shadow: 0px 16px 46.4px 0px #00000010 !important;
  }
}

.connect-another-subtitle {
  font-size: 14px;
  font-family: inherit;
  margin-bottom: 10px;
  margin-top: 10px;
  background: #FFE7C3;
  padding: 20px;
  border-radius: 16px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  font-weight: 100 !important;

  &.missing-data-subtitle {
    background-color: #FFDC73;
    text-align: center;
  }

  b {
    font-weight: 700;
    text-decoration: underline;
    cursor: pointer;
  }
}

.breakdown-content {
  width: 100%;
}

.breakdown-row {
  display: flex;
  padding: 15px 5px;
  border-bottom: 1px solid rgba(32, 84, 65, 0.2);

  &:last-child {
    border-bottom: none;
  }
}

.col {
  &.source {
    flex: 4;
    text-align: left;
  }

  &.invest {
    flex: 1;
    text-align: right;
    font-weight: 700;
  }

  .disabled & {
    color: #B0B0B0 !important;
  }
}

.breakdown-total-row {
  font-weight: 100;
}

.breakdown-total-row b {
  font-weight: 700;
}
</style>
